import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { combineLatest, from, of, switchMap } from 'rxjs';
import { defaultLanguage } from '../../consts';
import { getAllRouteData } from '../../lib/get-all-route-data';
import { getFullPath } from '../../lib/get-full-path';
import { PICFLOW_STORYBLOK } from '../../picflow-storyblok';
import { LanguageService } from '../../services/language.service';
import { RedirectService } from '../../services/redirect.service';

const redirect = async (url: string, redirectType: 'permanent' | 'temporary', redirectService: RedirectService) => {
  const path = url
    .split('?')[0]
    .split('#')[0]
    .split('/')
    .filter(a => a);
  return redirectService.redirectTo(path, { redirectType });
};

export const storyblokRedirectGuard: CanActivateFn = route => {
  const storyblokService = inject(PICFLOW_STORYBLOK);
  const redirectService = inject(RedirectService);
  const languageService = inject(LanguageService);

  const value = getAllRouteData(route).storyblokPathOverride || getFullPath(route).join('/') || 'home';

  const lang = languageService.currentLanguage();

  const searches = [
    lang === defaultLanguage
      ? of(null)
      : storyblokService.getStories({ filter_query: [{ key: `alias.alias__i18n__${lang}`, value }] }),
    storyblokService.getStories({ filter_query: [{ key: 'alias.alias', value }] }),
  ];

  return combineLatest(searches).pipe(
    switchMap(resps => {
      const resp = resps.find(r => r?.stories.length);
      if (!resp) return of(false);
      const redirectTo = resp.stories[0].full_slug;
      return from(redirect(redirectTo, 'permanent', redirectService));
    })
  );
};
